import { render, staticRenderFns } from "./purchaseCheckAdd.vue?vue&type=template&id=5b357abd&scoped=true&"
import script from "./purchaseCheckAdd.vue?vue&type=script&lang=js&"
export * from "./purchaseCheckAdd.vue?vue&type=script&lang=js&"
import style0 from "./purchaseCheckAdd.vue?vue&type=style&index=0&id=5b357abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b357abd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b357abd')) {
      api.createRecord('5b357abd', component.options)
    } else {
      api.reload('5b357abd', component.options)
    }
    module.hot.accept("./purchaseCheckAdd.vue?vue&type=template&id=5b357abd&scoped=true&", function () {
      api.rerender('5b357abd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilCheckManage/purchaseCheckAdd.vue"
export default component.exports